(function () {
  if (window.DKJSections) {
    window.DKJSections.init(document);
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    const elements = root.querySelectorAll('[data-dkj-reveal]:not([data-dkj-ready])');
    if (!elements.length) return;

    if (reducedMotion || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
      elements.forEach((element) => {
        element.dataset.dkjReady = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    elements.forEach((element) => {
      element.dataset.dkjReady = 'true';
      observer.observe(element);
    });
  }

  function initRails(root) {
    root.querySelectorAll('[data-dkj-rail-section]:not([data-dkj-rail-ready])').forEach((section) => {
      const rail = section.querySelector('[data-dkj-rail]');
      if (!rail) return;
      section.dataset.dkjRailReady = 'true';

      const move = (direction) => {
        const card = rail.querySelector('.dkj-product-card');
        const distance = card ? card.getBoundingClientRect().width + 18 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: distance * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      section.querySelector('[data-dkj-prev]')?.addEventListener('click', () => move(-1));
      section.querySelector('[data-dkj-next]')?.addEventListener('click', () => move(1));
    });
  }

  function initQuickViews(root) {
    root.querySelectorAll('[data-dkj-quick-view-open]:not([data-dkj-dialog-ready])').forEach((trigger) => {
      trigger.dataset.dkjDialogReady = 'true';
      trigger.addEventListener('click', () => {
        const dialog = document.getElementById(trigger.dataset.dkjQuickViewOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog.showModal();
        dialog.querySelector('[data-dkj-quick-view-close]')?.focus();
      });
    });

    root.querySelectorAll('[data-dkj-quick-view]:not([data-dkj-dialog-ready])').forEach((dialog) => {
      dialog.dataset.dkjDialogReady = 'true';
      dialog.querySelector('[data-dkj-quick-view-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.querySelector('[data-dkj-variant-select]')?.addEventListener('change', (event) => {
        const option = event.target.selectedOptions[0];
        const price = dialog.querySelector('[data-dkj-quick-view-price]');
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
      });
    });
  }

  function showFormError(form, message) {
    const error = form.querySelector('[data-dkj-form-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function initAjaxCart(root) {
    root.querySelectorAll('form.dkj-quick-add:not([data-dkj-cart-ready]), form.dkj-quick-view__form:not([data-dkj-cart-ready])').forEach((form) => {
      form.dataset.dkjCartReady = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

        const cartUi = document.querySelector('cart-notification, cart-drawer');
        const formData = new FormData(form);
        if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
          formData.append('sections', cartUi.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }

        showFormError(form, '');
        cartUi?.setActiveElement?.(document.activeElement);
        button.dataset.dkjOriginalLabel = button.textContent.trim();
        button.textContent = 'WIRD HINZUGEFÜGT…';
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'Das Produkt konnte nicht hinzugefügt werden.');

          form.closest('[data-dkj-quick-view]')?.close();
          if (cartUi && typeof cartUi.renderContents === 'function' && result.sections) {
            cartUi.renderContents(result);
          } else {
            const shopRoot = window.Shopify?.routes?.root || '/';
            window.location.assign(`${shopRoot}cart`);
          }
        } catch (error) {
          showFormError(form, error.message || 'Bitte versuche es erneut.');
        } finally {
          button.textContent = button.dataset.dkjOriginalLabel || 'HINZUFÜGEN';
          button.removeAttribute('aria-busy');
          button.removeAttribute('aria-disabled');
        }
      });
    });
  }

  function init(root) {
    document.documentElement.classList.add('dkj-motion-ready');
    initReveal(root);
    initRails(root);
    initQuickViews(root);
    initAjaxCart(root);
  }

  window.DKJSections = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
